export const networkError = 'brew/network-error';
export const resourceError = 'brew/resource-error';
export const apiError = 'brew/api-error';
export const validationFailed = 'brew/validation-failed';
export const navigationCancelled = 'brew/navigation-cancelled';
export const navigationRejected = 'brew/navigation-rejected';
export const timeout = "brew/timeout";
